import React from 'react';
import { motion } from 'framer-motion';
import heroBg from '../assets/images/hero-bg.jpg';

const Hero: React.FC = () => {
  return (
    <div className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" id="home">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={heroBg} 
          alt="Solaria Restaurant Interior" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-xl md:text-2xl font-light tracking-widest mb-4 text-orange-400 uppercase">Selamat Datang di</h2>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold font-serif mb-6 leading-tight">
            SOLARIA <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">MADIUN</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto mb-10">
            Nikmati aneka hidangan lezat mulai dari Nasi Goreng, Mie, hingga Western Food dengan cita rasa yang tak terlupakan.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#menu" 
              className="px-8 py-4 bg-purple-600 hover:bg-purple-700 text-white rounded-full font-semibold transition-all transform hover:scale-105 shadow-lg shadow-purple-900/50"
            >
              Lihat Menu
            </a>
            <a 
              href="#contact" 
              className="px-8 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-purple-900 text-white rounded-full font-semibold transition-all"
            >
              Lokasi Kami
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div 
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white"
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center p-1">
          <div className="w-1 h-2 bg-white rounded-full"></div>
        </div>
      </motion.div>
    </div>
  );
};

export default Hero;
